import React, { useEffect, useRef, useState } from "react";
import {  collection,  getDocs,  query,  where,  addDoc,  doc,  updateDoc,  setDoc,  Timestamp,  writeBatch,  serverTimestamp} from "firebase/firestore";
import * as XLSX from "xlsx";
import { db, auth } from "../firebase";

/* ---------------- HELPERS ---------------- */
const isFirstDayOfMonth = (dateStr) => {
  return dateStr.endsWith("-01");
};

const isAfter1159 = () => {
  const now = new Date();
  const ist = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  return ist.getHours() === 23 && ist.getMinutes() >= 59;
};

const todayStr = () => new Date().toISOString().slice(0, 10);

const isFirstOfMonth = (dateStr) => dateStr.endsWith("-01");
const WAREHOUSE_START_DATE = "2026-01-01";

const prevDateStr = (dateStr) => {
  const d = new Date(dateStr);
  d.setDate(d.getDate() - 1);
  return d.toISOString().slice(0, 10);
};

/* ---------------- COMPONENT ---------------- */

export default function WarehouseClose() {
  const [date, setDate] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [skuReady, setSkuReady] = useState(false);
  const [warning, setWarning] = useState("");

const sum = (key) =>
  rows.reduce((t, r) => t + Number(r[key] || 0), 0).toFixed(2);


  // 🔒 caches to reduce reads
  const skuOrderRef = useRef({});
  const dateCacheRef = useRef({});

  /* ---------- LOAD SKU MASTER (ONCE) ---------- */
  useEffect(() => {
    const loadSkuMaster = async () => {
      const snap = await getDocs(collection(db, "skuMaster"));
	  
	  
	  
	  
	  
      const map = {};
const skuList = [];

snap.forEach(d => {
  const x = d.data();
  if (x.sku) {
    map[x.sku] = Number(x.sortorder ?? 9999);
    skuList.push(x.sku);
	
  }
});

skuOrderRef.current = map;
skuOrderRef.current.__ALL_SKUS__ = skuList;

setSkuReady(true); // ✅ ADD THIS
	  
	  
	  
	  
	  
    };
    loadSkuMaster();
  }, []);

  /* ---------- SORT ---------- */
  const sortBySku = (a, b) => {
    const sa = skuOrderRef.current[a.sku] ?? 9999;
    const sb = skuOrderRef.current[b.sku] ?? 9999;
    return sa - sb;
  };

  /* ---------- LOAD DATE ---------- */
  const loadDate = async (d) => {
	  
	    // raviprabu 08.01.2026 added for closing stock 

    
	if (!skuOrderRef.current.__ALL_SKUS__) return;

	
	if (dateCacheRef.current[d]) {
      setRows(dateCacheRef.current[d]);
      return;
    }

    setLoading(true);

    // 1️⃣ READ DAILY_STOCK ONLY
    const dsSnap = await getDocs(
      query(collection(db, "daily_stock"), where("date", "==", d))
    );

    // Map existing daily_stock by SKU
const existingMap = {};
dsSnap.forEach(d => {
  existingMap[d.data().sku] = { id: d.id, ...d.data() };
});

// ALWAYS iterate full skuMaster
const allSkus = skuOrderRef.current.__ALL_SKUS__;
const finalRows = [];





for (let sku of allSkus) {
  if (existingMap[sku]) {
    finalRows.push(existingMap[sku]);
  } else {
    // create ZERO row for missing SKU
    const ref = await addDoc(collection(db, "daily_stock"), {
      date: d,
      sku,
      openingQty: 0,
      inwardQty: 0,
      invoiceQty: 0,
      inwardMTD: null,
      invoiceMTD: null,
      systemClosing: 0,
      physicalQty: null,
      damageQty: null,
      variance: null,
      remarks: "",
      dayClosed: false,
      createdAt: serverTimestamp(),
      createdBy: auth.currentUser.email || auth.currentUser.uid
    });

    finalRows.push({
      id: ref.id,
      sku,
      openingQty: 0,
      inwardQty: 0,
      invoiceQty: 0,
      inwardMTD: 0,
      invoiceMTD: 0,
      systemClosing: 0,
      physicalQty: "",
      damageQty: "",
      variance: 0,
      remarks: "",
      dayClosed: false
    });
  }
}

finalRows.sort(sortBySku);
setRows(finalRows);
setLoading(false);


    
    finalRows.sort(sortBySku);
    dateCacheRef.current[d] = finalRows;
    setRows(finalRows);
    setLoading(false);
	
	
  // 🔔 ADD THIS LINE EXACTLY HERE
  await checkPendingDays(date);
	
  };

 useEffect(() => {
  if (!skuReady) return;
  if (!date) return;   // 🔒 wait until user selects date
  loadDate(date);
}, [date, skuReady]);


useEffect(() => {
  if (!date) return;
  if (rows.length === 0) return;
  if (rows.some(r => r.dayClosed)) return;

  if (isAfter1159()) {
    closeDay();
  }
}, [rows, date]);



  /* ---------- DAY CLOSE ---------- */
  const closeDay = async () => {
	  
	  // 🔒 SAFETY CHECKS BEFORE CLOSE DAY

// 1️⃣ Check previous days
const ok = await checkPendingDays(date);
if (!ok) {
  alert("Close previous day(s) before closing today.");
  return;
}

// 2️⃣ Check rebuild completeness
for (let r of rows) {
  if (r.inwardQty == null || r.invoiceQty == null) {
    alert(`Rebuild pending for SKU ${r.sku}. Cannot close day.`);
    return;
  }
}

	  
	  const prevDate = prevDateStr(date);

const prevSnap = await getDocs(
  query(collection(db, "daily_stock"), where("date", "==", prevDate))
);

const prevMTDMap = {};
prevSnap.forEach(d => {
  const x = d.data();
  prevMTDMap[x.sku] = {
    inwardMTD: Number(x.inwardMTD || 0),
    invoiceMTD: Number(x.invoiceMTD || 0),
  };
});

	  
	  
    for (let r of rows) {
		
		
      const physical = Number(r.physicalQty || 0);
      const damage = Number(r.damageQty || 0);
      const variance = r.systemClosing - physical - damage;

const todayInward = Number(r.inwardQty || 0);
const todayInvoice = Number(r.invoiceQty || 0);





const prev = prevMTDMap[r.sku] || { inwardMTD: 0, invoiceMTD: 0 };

const inwardMTD = isFirstDayOfMonth(date)
  ? todayInward
  : prev.inwardMTD + todayInward;

const invoiceMTD = isFirstDayOfMonth(date)
  ? todayInvoice
  : prev.invoiceMTD + todayInvoice;




      await updateDoc(doc(db, "daily_stock", r.id), {
        physicalQty: physical,
        damageQty: damage,
        variance,
		inwardMTD,
  invoiceMTD,
		
		
        remarks: r.remarks || "",
        dayClosed: true,
        closedAt: serverTimestamp(),
        closedBy: auth.currentUser.email || auth.currentUser.uid
      });
	  
	  await carryForwardOpening(
  new Date(date + "T00:00:00")
    .toISOString()
    .slice(0, 10)
);

    }
	
	
	
    alert("Day closed successfully");
    dateCacheRef.current = {};
    loadDate(date);
  };


//        NEXT//

const rebuildInwardAndInvoice = async () => {
  if (!date) {
    alert("Select date first");
    return;
  }

  /* -------------------------
     1️⃣ READ INWARD REGISTER
  --------------------------*/
  const inwardSnap = await getDocs(
    query(
      collection(db, "inward_register"),
      where("inwardDate", "==", date)
    )
  );

  const inwardMap = {};
  inwardSnap.forEach(doc => {
    const d = doc.data();
    inwardMap[d.sku] = (inwardMap[d.sku] || 0) + Number(d.quantity || 0);
  });

  /* -------------------------
     2️⃣ READ APPROVED INVOICES
  --------------------------*/
  const invoiceSnap = await getDocs(
    query(
      collection(db, "orderLines"),
      where("approvedDateOnly", "==", date),
      where("status", "==", "APPROVED")
    )
  );

  const invoiceMap = {};
  invoiceSnap.forEach(doc => {
    const d = doc.data();
    invoiceMap[d.sku] = (invoiceMap[d.sku] || 0) + Number(d.qty || 0);
  });

  /* -------------------------
     3️⃣ UPDATE DAILY_STOCK
  --------------------------*/
  for (const row of rows) {
    const inward = Number(inwardMap[row.sku] || 0);
    const invoice = Number(invoiceMap[row.sku] || 0);
    const opening = Number(row.openingQty || 0);

    const systemClosing = opening + inward - invoice;

    await updateDoc(
      doc(db, "daily_stock", row.id),
      {
        inwardQty: inward,
        invoiceQty: invoice,
        systemClosing,
        updatedAt: serverTimestamp(),
      }
    );
  }

  alert("Inward + Invoice rebuild completed");
  
  // 👇 ADD THIS BLOCK
const next = new Date(date);
next.setDate(next.getDate() + 1);
const nextDate = next.toISOString().slice(0, 10);

await carryForwardOpening(nextDate);
  
  
  
  
  loadDate(date); // refresh screen
};
// help//



const exportClosing = () => {
  const data = rows.map(r => ({
    Date: date,
    SKU: r.sku,
    Opening: r.openingQty,
    Inward: r.inwardQty,
    Invoice: r.invoiceQty,
	InwardMTD: r.inwardMTD,
	InvoiceMTD: r.invoiceMTD,
	
	
	
    SystemClosing: r.systemClosing,
    Physical: r.physicalQty,
    Damage: r.damageQty,
    Variance: r.variance,
    Remarks: r.remarks || ""
  }));

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Closing");

  XLSX.writeFile(wb, `Warehouse_Closing_${date}.xlsx`);
};







const carryForwardOpening = async (selectedDate) => {
  const prev = new Date(selectedDate);
  prev.setDate(prev.getDate() - 1);
  const prevDate = prev.toISOString().slice(0, 10);

  // 1️⃣ Read yesterday closing
  const prevSnap = await getDocs(
    query(
      collection(db, "daily_stock"),
      where("date", "==", prevDate)
    )
  );

  const prevMap = {};
  prevSnap.forEach(d => {
    const x = d.data();
    prevMap[x.sku] = Number(x.systemClosing || 0);
  });

  // 2️⃣ Read today records
  const todaySnap = await getDocs(
    query(
      collection(db, "daily_stock"),
      where("date", "==", selectedDate)
    )
  );

  const todayMap = {};
  todaySnap.forEach(d => {
    todayMap[d.data().sku] = { id: d.id, ...d.data() };
  });

  // 3️⃣ Write openingQty
  const batch = writeBatch(db);

  
  const allSkus = skuOrderRef.current.__ALL_SKUS__ || [];

allSkus.forEach(sku => {
  const opening = prevMap[sku] ?? 0;

  if (todayMap[sku]) {
    batch.update(doc(db, "daily_stock", todayMap[sku].id), {
      openingQty: opening
    });
  } else {
    batch.set(doc(collection(db, "daily_stock")), {
      sku,
      date: selectedDate,
      openingQty: opening,
      inwardQty: 0,
      invoiceQty: 0,
      systemClosing: opening,
      dayClosed: false,
      createdAt: serverTimestamp(),
      createdBy: auth.currentUser?.email || "system"
    });
  }
});


  await batch.commit();
};




//autoclose - raviprbau at 11.59 pm//

const autoDayClose = async () => {
  const now = new Date();
  if (now.getHours() !== 23 || now.getMinutes() !== 59) return;

  const today = now.toISOString().slice(0, 10);

  const snap = await getDocs(
    query(
      collection(db, "daily_stock"),
      where("date", "==", today),
      where("dayClosed", "==", false)
    )
  );

  if (snap.empty) return;

  const batch = writeBatch(db);

  snap.forEach(d => {
    batch.update(doc(db, "daily_stock", d.id), {
      dayClosed: true,
      closedAt: serverTimestamp()
    });
  });

  await batch.commit();

  // prepare next day opening
  const next = new Date();
  next.setDate(next.getDate() + 1);
  const nextDate = next.toISOString().slice(0, 10);

  await carryForwardOpening(nextDate);
};



useEffect(() => {
  const timer = setInterval(async () => {
    const now = new Date();
    const ist = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );

    if (ist.getHours() === 23 && ist.getMinutes() === 59) {
      await closeDay();

      const next = new Date(ist);
      next.setDate(next.getDate() + 1);
      const nextDate = next.toISOString().slice(0, 10);

      await carryForwardOpening(nextDate);
    }
  }, 60000); // check every minute

  return () => clearInterval(timer);
}, [rows, date]);





const checkPendingDays = async (selectedDate) => {
  const snap = await getDocs(
    query(
      collection(db, "daily_stock"),
      where("dayClosed", "==", false)
    )
  );

  const pending = snap.docs.filter(d => {
    const dDate = d.data().date;
    return (
      dDate >= WAREHOUSE_START_DATE &&
      dDate < selectedDate
    );
  });

  if (pending.length > 0) {
    setWarning("⚠️ Previous day is not closed. Please close it before proceeding.");
    return false;
  }

  setWarning("");
  return true;
};










  /* ---------- UI ---------- */
  return (
    <div>
      <h2>Warehouse Closing</h2>

      <input type="date" value={date} onChange={e => setDate(e.target.value)} />
      
	  <button onClick={rebuildInwardAndInvoice}>
  Rebuild Inward + Invoice
</button>

	  
	  
<button onClick={exportClosing}>
  Export
</button>

	  <button onClick={closeDay}>Close Day</button>

      {loading && <p>Loading…</p>}


{warning && (
  <div style={{
    background: "#fff3cd",
    color: "#856404",
    padding: "10px",
    marginBottom: "10px",
    border: "1px solid #ffeeba",
    borderRadius: "4px",
    fontWeight: "bold"
  }}>
    {warning}
  </div>
)}




      <table border="1">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Opening</th>
            <th>Inward</th>
            <th>Inward MTD</th>
            <th>Invoice</th>
            <th>Invoice MTD</th>
            <th>System Closing</th>
            <th>Physical</th>
            <th>Damage</th>
            <th>Variance</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id}>
              <td>{r.sku}</td>
              
			  
			  <td>{Number(r.openingQty || 0) .toFixed(2)}</td>
              <td>{Number(r.inwardQty || 0) .toFixed(2)}</td>
              <td>{Number(r.inwardMTD || 0) .toFixed(2)}</td>
              <td>{Number(r.invoiceQty || 0) .toFixed(2)}</td>
              <td>{Number(r.invoiceMTD || 0) .toFixed(2)}</td>
              <td>
  {(
    Number(r.openingQty || 0) +
    Number(r.inwardQty || 0) -
    Number(r.invoiceQty || 0)
  ).toFixed(2)}
</td>


              <td>
                <input
                  value={r.physicalQty}
                  disabled={r.dayClosed}
                  onChange={e => {
                    const v = [...rows];
                    v[i].physicalQty = e.target.value;
                    setRows(v);
                  }}
                />
              </td>

              <td>
                <input
                  value={r.damageQty}
                  disabled={r.dayClosed}
                  onChange={e => {
                    const v = [...rows];
                    v[i].damageQty = e.target.value;
                    setRows(v);
                  }}
                />
              </td>

              <td>
                {(r.systemClosing -
                  Number(r.physicalQty || 0) -
                  Number(r.damageQty || 0)).toFixed(2)}
              </td>

              <td>
                <input
                  value={r.remarks}
                  disabled={r.dayClosed}
                  onChange={e => {
                    const v = [...rows];
                    v[i].remarks = e.target.value;
                    setRows(v);
                  }}
                />
              </td>
            </tr>
          ))}
		  
		  
		  
		  
		  
		  <tr style={{ fontWeight: "bold", background: "#f2f2f2" }}>
  <td>Total</td>

  <td>{sum("openingQty")}</td>
  <td>{sum("inwardQty")}</td>
  <td>{sum("inwardMTD")}</td>
  <td>{sum("invoiceQty")}</td>
  <td>{sum("invoiceMTD")}</td>
  <td>{sum("systemClosing")}</td>

  <td>{sum("physicalQty")}</td>
  <td>{sum("damageQty")}</td>
  <td>{sum("variance")}</td>

  <td></td>
</tr>

		  
		  
		  
		  
		  
		  
		  
		  
		  
        </tbody>
      </table>
    </div>
  );
}
